import React, { useEffect, useCallback } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";
import ReactDOM from "react-dom";

const Backdrop = styled.div`
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  pointer-events: none;

  &.show {
    opacity: 1;
    pointer-events: visible;
  }

  .wrapper {
    min-width: 500px;
    position: relative;
  }
`;

const ModalContent = styled.div`
  background-color: #fff;
  transition: all 0.3s ease-in-out;
  background-color: ${(props) =>
    `${props.isBackgroundWhite ? "white" : "#f4f5fb"}`};
  border: 14px solid ${theme.colors.white};
  border-radius: 10px;
  padding: 34px 32px;

  .closeButton {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(40px, -35px);
  }
`;

const Modal = ({
  show,
  children,
  onClose,
  showCloseBtn = true,
  isBackgroundWhite = false,
}) => {
  const closeOnEscapeKeyDown = useCallback(
    (e) => {
      if ((e.charCode || e.keyCode) === 27) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, [closeOnEscapeKeyDown]);

  return ReactDOM.createPortal(
    <Backdrop className={`${show ? "show" : ""}`} onClick={onClose}>
      <div className="wrapper" onClick={(e) => e.stopPropagation()}>
        <ModalContent isBackgroundWhite={isBackgroundWhite}>
          {children}
        </ModalContent>
      </div>
    </Backdrop>,
    document.getElementById("root")
  );
};

export default Modal;
